/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { takeLatest, ForkEffect } from 'redux-saga/effects';
import ActionConstants from '../constants';
import workerSaga from './workerSaga';
// ------------------------------------
// Watchers
// ------------------------------------
export default function* partnerMerchantWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLatest(ActionConstants.GET_ALL_MERCHANT_LIST, workerSaga);
  yield takeLatest(ActionConstants.GET_ALL_TRANSACTION_LIST, workerSaga);
  yield takeLatest(ActionConstants.GET_PARTNER_SUMMARY_GRAPH, workerSaga);
  yield takeLatest(ActionConstants.GET_ALL_MERCHANT_SUMMARY_LIST, workerSaga);
  yield takeLatest(ActionConstants.GET_LEAD_SUMMARY, workerSaga);
  yield takeLatest(ActionConstants.GET_PARTNER_SUB_MERCHANT_LIST, workerSaga);
  yield takeLatest(ActionConstants.GET_PARTNER_ONBOARDING_STAGE_LIST, workerSaga);
  yield takeLatest(ActionConstants.INVITE_PARTNER_MERCHANT, workerSaga);
  yield takeLatest(ActionConstants.GET_PARTNER_PAYMENT_METHODS, workerSaga);
}


